/**
 * Move the same working controls into a dialog's top layer. No cloned IDs,
 * duplicate listeners or separate preferences. Return them before DOM replacement.
 */
export function createSectionSettingsDock(controls: HTMLElement, closeMenus: () => void) {
  const anchor = document.createComment('section-settings-home');
  controls.before(anchor);
  let activeHost: HTMLElement | null = null;
  return {
    mount(host: HTMLElement): () => void {
      closeMenus();
      activeHost = host;
      host.append(controls);
      return () => {
        if (activeHost !== host) return;
        closeMenus();
        anchor.after(controls);
        activeHost = null;
      };
    },
  };
}
